import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
import { useCallback } from "react";

import { useUserStore as useOldUserStore } from "./UserStore";
import { useUserStore as useNewUserStore } from "./useUserStore";

export const useSetUser = () => {
  const { setUser: setUserNew } = useNewUserStore(["setUser"]);
  const { setUser: setUserOld } = useOldUserStore(["setUser"]);

  return useCallback(
    (user: IUser | undefined) => {
      setUserNew(user);
      setUserOld(user);
    },
    [setUserNew, setUserOld]
  );
};

export const useFetchUser = () => {
  const { fetchUser: fetchUserNew } = useNewUserStore(["fetchUser"]);
  const { fetchUser: fetchUserOld } = useOldUserStore(["fetchUser"]);

  return useCallback(async () => {
    await Promise.all([fetchUserNew(), fetchUserOld()]);
  }, [fetchUserNew, fetchUserOld]);
};
